import 'mapbox-gl/dist/mapbox-gl.css';
import * as React from 'react';
import { useState } from 'react';
import '../../css/style.css';
import MapLayout from '../MapLayout/MapLayout';
import Navbar from '../Navbar/Navbar';
import Charts from '../Charts/Charts';
import Footer from '../Footer/Footer';
import places from "../../data/placeData.json";
import updateURLparameter from './utils/updateURLparameter';

interface Place {
    id: number;
    groupId: number
    lat: number;
    long: number
}
interface props {
    groupID:number | undefined | null,
    startyear:number | 0,
    startmonth:number | 1,
    startday:number | 1,
}
export function findDefaultValueGroupID(groupID:any,places:any){
    if(!groupID || !places)
      return "-1"
    return places.findIndex((place:any) => place.groupId === groupID)
}
export function findPlaceByGroupID(groupID:any){
    let place = places.find((place:any)=> place.groupId === groupID) ?? places[0];
    let newId = findDefaultValueGroupID(groupID, places);
    if (newId === "-1") { newId = 0; }
    return { id: newId,
        groupId: place.groupId, lat: place.coordinates[0], long: place.coordinates[1]}
}
const Home = ({groupID,startyear,startmonth,startday}:props) => {
    const [place, setPlace] = useState<Place>(findPlaceByGroupID(groupID)); //
    let placeId = findDefaultValueGroupID(groupID, places);
    if (placeId === "-1") { placeId = 0; }
    let loc = "No data";
    let num = 1;
    let plac = "";
    let notes = "";
    // console.log(placeId);
    if (placeId !== "-1") {
      loc = places[placeId].location;
      num = places[placeId].number_of_sensors;
      plac = places[placeId].placement;
      notes = places[placeId].note;
    }
    const [currentData, setCurrentData] = useState({});
    const [currentStatus, setCurrentStatus] = useState({});

    //Set place accoridng to group ID, if the group id doesnt exist set to 0th place
    React.useEffect(()=>{
        if(groupID){
            setPlace(findPlaceByGroupID(groupID))
            }
            //if navigating to "/" aka group 1 add "groupID=1" to the URL
            const newURL = updateURLparameter(window.location.href, "groupID", place.groupId) 
            window.history.replaceState( {} , document.title, newURL ) 
    }, [groupID, place.groupId])
    return (
        <div className='container__home'>
            <Navbar places={places} groupID={groupID} setPlace={(place)=>{
                const newURL = updateURLparameter(window.location.href, "groupID",place.groupId) 
                //when changing from navbar basically reload the page
                window.location.href = newURL
                //Or do no reload (also doesnt push to history so back/forward browser buttons dont work)
                //If ever needed for debugging
                // window.history.replaceState( {} , document.title, newURL )
                setPlace(place)
            }}></Navbar>
            <div className='container__home--row-1'>
                <MapLayout key={place.id} groupId={place.groupId} long={place.long} lat={place.lat} currentData={currentData} currentStatus={currentStatus}></MapLayout>
            </div>
            <div className="container__home--row-2">
                <div className='data-box'>
                    <div className='data-box--chart'>
                        <Charts key={place.id} groupId={place.groupId} setCurrentData={setCurrentData} setCurrentStatus={setCurrentStatus} startyear={startyear} startmonth={startmonth} startday={startday}></Charts>
                    </div>
                </div>
            </div>
            <div className="container__home--row-1">
                <div className="center-panel">
                <b>Location</b>: {loc}<br />
                <b>Number of sensors</b>: {num}<br />
                <b>Placement</b>: {plac}<br />
                <b>Notes</b>: {notes}
                </div>
            </div>
            <br /><br />
            <Footer></Footer>
        </div>
    );
};

export default Home;
